import { Stack, Button, Typography, Grid, IconButton } from "@mui/material";
import useOrderStore from "../../../stores/useOrderStore";
import { useState } from "react";
import WushTextField from "../../form/WushTextField";
import update from "../../../api/auth/orders/update";
import { Add, Edit } from "@mui/icons-material";
import useAlertStore from "../../../stores/useAlertStore";

export default function OrderTip({ order, handleSubmit }) {
  const [ tip, setTip ] = useState(order.tip_dollars);
  const { updateOrder } = useOrderStore();

  const [ showTipEntry, setShowTipEntry ] = useState();
  const { setAlertMessage } = useAlertStore();

  const onSubmit = () => {
    if(handleSubmit) {
      handleSubmit(tip);
      setShowTipEntry(false);
    } else {
      update(order.id, { tip: tip }, (response) => {
        updateOrder(response);
        setShowTipEntry(false);
      }, () => {
        setAlertMessage("Invalid tip amount", "error");
      });
    }
  };

  return (
    <Stack width={{ xs: "100%" }}>
      {showTipEntry ?
        <Stack direction="row" spacing={2}>
          <WushTextField
            defaultValue={tip}
            formRegistration={{
              onChange: (e) => setTip(e.target.value)
            }}
            label="Tip amount"
            type="number"
          />
          <Button onClick={onSubmit} variant="contained">Save</Button>
        </Stack>
        :
        <Stack direction="row" spacing={3} width={{ xs: "100%" }}>
          { parseInt(tip) > 0 &&
            <Grid container my="auto">
              <Grid item xs={6} sm={10} display="flex">
                <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
                  Tip
                </Typography>
              </Grid>
              <Grid item xs={6} sm={2} display="flex" textAlign={{ xs: "right", sm: "left" }}>
                <Typography sx={{ my: "auto" }} variant="body1">
                  ${tip}
                </Typography>
              </Grid>
            </Grid>
          }
          {
            parseInt(tip) === 0 && <Typography sx={{ my: "auto !important" }} variant="body1" fontWeight="700">Tip</Typography>
          }
          <IconButton size="small" onClick={() => setShowTipEntry(true)}>
            {parseInt(tip) > 0 ? <Edit /> : <Add />}
          </IconButton>
        </Stack>
      }
    </Stack>
  );
}